import { useEffect } from "react";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import TransferTaskCard from "components/TransferTaskCard";

export default function PalettesList() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const { view, palettesTable, palettesList } = map;

  const handlePaletteDetails = (palette) => {
    dispatchMap({
      type: "INIT",
      payload: {
        paletteTrackingComponentMode: "paletteDetails",
        selectedPalette: palette,
      },
    });
  };

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        const orderByFields = ["created_date DESC"];
        if (palettesTable && view && token) {
          const { res: palettesRes } = await getEsriDataFromLayer({
            featureLayer: palettesTable,
            orderByFields,
          });

          dispatchMap({
            type: "INIT",
            payload: {
              palettesList: palettesRes,
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, palettesTable]);

  return (
    <div
      className="meters"
      style={{
        position: "relative",
        alignContent: palettesList?.length ? "normal" : "center",
      }}
    >
      {palettesList?.length ? (
        palettesList.map((palette) => (
          <TransferTaskCard
            toggleDetails={handlePaletteDetails}
            itemId={palette.Pallet_ID}
            itemIdText="Palette ID"
            headingValue={palette.Stage}
            headingText="Status"
            date={palette.created_date_ISO}
            item={palette}
            key={palette.OBJECTID}
          />
        ))
      ) : (
        <div className="text-center">No Results Found</div>
      )}
    </div>
  );
}
